import empty from '../assets/images/empty.png';

export const imgAWSPath = (img) => {
  return img ? `https://sc-appm-prx.s3.eu-west-3.amazonaws.com/images/profile/${img}` : empty;
}